export const PARTICIPANT_NUMBER_PREFIX = 'MEDA';
